import { z } from 'zod'

export const householdNameSchema = z
  .string()
  .min(1, 'household.error.nameRequired')
  .max(100, 'household.error.nameTooLong')

export const inviteCodeSchema = z
  .string()
  .length(8, 'household.error.codeRequired')
  .regex(/^[A-Z0-9]+$/, 'household.error.codeInvalid')
